import { FocusEvent } from 'react';

import { TextFieldProps } from '../TextField/types';

export type AutocompleteSelectProps = Omit<TextFieldProps, 'value'> & {
  value: AutocompleteOptionProps;
  options: any;
  placeholder?: string;
  masked?: boolean;
  mask?: 'exp-date-month' | 'exp-date-year' | 'qty';
  noOptionText?: string;
  suggestionClassName?: string;
  onSelect?: any;
  isDisabled?: boolean;
  onBlur?: (e: FocusEvent<HTMLInputElement>) => any;
  onChange?: any;
};

export type AutocompleteOptionProps = {
  label: number | string;
  value: number | string;
};

export type AutoCompleteItemProps = {
  option: AutocompleteOptionProps;
  onSelectItem?: any;
  isHighlighted?: boolean;
  isActive?: boolean;
};

export const maskRegex = {
  qty: new RegExp(/^(\s+|[1-9]\d{0,2})?$/g),
  'exp-date-month': new RegExp(/^(\s+|[1-9]\d{0,1})?$/g),
  'exp-date-year': new RegExp(/^(\s+|[1-9]\d{0,1})?$/g),
};

export type DropdownIndicatorProps = {
  disabled: boolean | undefined;
  showOptions: boolean;
  onClick: (event: any) => void;
};
